module.exports = __webpack_public_path__ + "media/images/icons/editardatos-d95dab9156e974263a78e8f0f783c6f6.svg";